export const de = {
  nav: { services: "Leistungen", sectors: "Sektoren", loans: "Darlehen", team: "Führung", contact: "Kontakt", cta: "Finanzierung anfragen" },
  hero: {
    eyebrow: "Kanadisches institutionelles Kapital",
    line1: "Kapital, das Industrien",
    line2: "voranbringt",
    sub: "Pacific Investment Group investiert in großem Maßstab, vergibt Darlehen und schließt strategische Partnerschaften in sieben Schlüsselsektoren — von Landwirtschaft und Bildung bis Infrastruktur und Luftfahrt.",
    cta1: "Finanzierung anfragen",
    cta2: "Leistungen entdecken",
    scroll: "Scrollen Sie",
    m1: "Kapital investiert",
    m2: "Finanzierte Projekte",
    m3: "Kundenzufriedenheit",
    m4: "Kernsektoren",
  },
  services: {
    eyebrow: "Was wir tun",
    title: "Drei Wege, wie wir aufbauen",
    sub: "Institutionelles Kapital, strukturiert für die Unternehmen, die die Welt am Laufen halten.",
    s1t: "Investition",
    s1d: "Institutionelles Eigenkapital und Joint Ventures, die vielversprechende Unternehmen zu Marktführern machen.",
    s1f1: "Eigenkapital & Joint Ventures",
    s1f2: "Projektstrukturierung",
    s1f3: "Langfristiges Wachstum",
    s2t: "Darlehen",
    s2d: "Großvolumige Fremdfinanzierung für kleine und große Unternehmen — kommerzielle Darlehen, strukturiert für Wachstum.",
    s2f1: "500 T$ bis 100 M$+",
    s2f2: "Schnelle Genehmigung",
    s2f3: "Flexible Rückzahlung",
    s3t: "Partnerschaft",
    s3d: "Strategische Koinvestitionen mit operativer Begleitung und globalen Netzwerken.",
    s3f1: "Koinvestitionsmodelle",
    s3f2: "Operationale Begleitung",
    s3f3: "Globale Netzwerke",
  },
  sectors: {
    eyebrow: "Wo wir investieren",
    title: "Sieben Sektoren. Ein Standard.",
    sub: "Wir setzen Großkapital in den Industrien ein, die das nächste Jahrhundert prägen.",
    ag: "Landwirtschaft", agd: "Modernes AgTech und nachhaltige landwirtschaftliche Betriebe im großen Maßstab.",
    edu: "Bildung", edud: "Campusentwicklung und Lerninfrastruktur der nächsten Generation.",
    re: "Immobilien", red: "Kapital für Gewerbe-, Wohn- und Mischbauvorhaben.",
    ind: "Industrieentwicklung", indd: "Fertigungsanlagen, Logistikparks und Industriegebiete.",
    inf: "Infrastruktur", infd: "Verkehrskorridore, Energieanlagen und öffentliche Versorgung.",
    aut: "Automatisierung", autd: "Robotik und KI-gesteuerte Fertigungssysteme.",
    avi: "Luftfahrt", avid: "Flugzeugleasing, Flottenfinanzierung und Flughafenentwicklung.",
  },
  loans: {
    eyebrow: "Fremdfinanzierung",
    title: "Großvolumige Darlehen für ernsthafte Unternehmen.",
    desc: "Von 500 T$ bis über 100 M$ — wir strukturieren kommerzielle Fremdfinanzierung für kleine und große Unternehmen: schnelle Genehmigungen, flexible Rückzahlung und Konditionen, die Ihr Eigenkapital schützen.",
    f1: "Flexible Rückzahlungsbedingungen",
    f2: "Schneller Genehmigungsprozess",
    f3: "Wettbewerbsfähige Zinsen",
    f4: "Keine Verwässerung des Eigenkapitals",
    slider: "Ihr Finanzierungsbedarf",
    cta: "Darlehensanfrage starten",
    steps: "Anfrage → Prüfung → Genehmigung → Auszahlung",
  },
  stats: { l1: "Kapital investiert", l2: "Finanzierte Projekte", l3: "Kundenzufriedenheit", l4: "Kernsektoren" },
  marquee: ["Investition", "Landwirtschaft", "Darlehen", "Bildung", "Partnerschaft", "Immobilien", "Infrastruktur", "Automatisierung", "Luftfahrt"],
  team: {
    eyebrow: "Führung",
    title: "Die Menschen hinter dem Kapital.",
    sub: "Ein vielfältiges Führungsteam mit Jahrzehnten Erfahrung in globalen Märkten.",
    r1: "Chief Executive Officer (CEO)",
    r2: "Senior VP, Globale Investitionen",
    r3: "Leiter Infrastruktur & Fremdfinanzierung",
    r4: "Direktorin, Immobilien & nachhaltige Entwicklung",
    r5: "Chief Financial Officer (CFO)",
    r6: "Ressortleiterin Recht & Compliance",
  },
  form: {
    eyebrow: "Kontakt",
    title: "Erzählen Sie uns von Ihrem Projekt.",
    sub: "Teilen Sie einige Details mit — unser Team antwortet innerhalb eines Werktags.",
    name: "Vollständiger Name",
    email: "E-Mail-Adresse",
    phone: "Telefon",
    company: "Unternehmen",
    service: "Ich interessiere mich für",
    sector: "Sektor",
    amount: "Finanzierungsbetrag",
    amountPh: "z. B. 2,5 M$",
    message: "Über Ihr Projekt",
    messagePh: "Beschreiben Sie kurz Ihr Unternehmen und Ihren Finanzierungsbedarf…",
    pick: "Sektor auswählen",
    submit: "Anfrage senden",
    submitting: "Wird gesendet…",
    success: "Anfrage erhalten — unser Team meldet sich innerhalb von 24 Stunden.",
    error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder schreiben Sie uns auf WhatsApp.",
    required: "Bitte füllen Sie Name, E-Mail und Nachricht aus.",
    invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    safe: "Ihre Informationen bleiben jederzeit vertraulich und 100 % sicher.",
  },
  contact: {
    eyebrow: "Kontakt",
    title: "Sprechen Sie direkt mit uns.",
    whatsapp: "WhatsApp",
    waCta: "Per WhatsApp chatten",
    email: "E-Mail",
    emCta: "E-Mail senden",
    address: "Büro",
    dir: "Route planen",
    hours: "Mo–Fr, 9:00–18:00 EST",
  },
  footer: {
    tagline: "Institutionelles Kapital für die Sektoren, die morgen gestalten.",
    rights: "© 2026 Pacific Investment Group. Alle Rechte vorbehalten.",
    privacy: "Datenschutz",
    disclaimer: "Pacific Investment Group bietet gewerbliche Finanzierungs- und Anlagedienstleistungen an. Alle Anfragen sind vorbehaltlich Prüfung und Genehmigung.",
  },
};

export const it = {
  nav: { services: "Servizi", sectors: "Settori", loans: "Prestiti", team: "Leadership", contact: "Contatti", cta: "Richiedi un finanziamento" },
  hero: {
    eyebrow: "Capitale istituzionale canadese",
    line1: "Capitale che muove",
    line2: "le industrie avanti",
    sub: "Pacific Investment Group deposita investimenti su larga scala, prestiti e partnership strategiche in sette settori essenziali — dall'agricoltura e istruzione alle infrastrutture e aviazione.",
    cta1: "Richiedi un finanziamento",
    cta2: "Scopri i nostri servizi",
    scroll: "Scorri per esplorare",
    m1: "Capitale investito",
    m2: "Progetti finanziati",
    m3: "Soddisfazione dei clienti",
    m4: "Settori chiave",
  },
  services: {
    eyebrow: "Cosa facciamo",
    title: "Tre modi di costruire",
    sub: "Capitale istituzionale, strutturato per le imprese che tengono in moto il mondo.",
    s1t: "Investimento",
    s1d: "Partecipazioni istituzionali e joint venture che trasformano imprese promettenti in leader di categoria.",
    s1f1: "Equity & joint venture",
    s1f2: "Strutturazione di progetti",
    s1f3: "Crescita a lungo termine",
    s2t: "Prestiti",
    s2d: "Finanziamento debito su larga scala per piccole e grandi imprese — prestiti commerciali strutturati per la crescita.",
    s2f1: "Da 500K$ a 100M$+",
    s2f2: "Approvazione rapida",
    s2f3: "Rimborso flessibile",
    s3t: "Partnership",
    s3d: "Coinvestimenti strategici con guida operativa concreta e reti globali.",
    s3f1: "Modelli di coinvestimento",
    s3f2: "Guida operativa",
    s3f3: "Reti globali",
  },
  sectors: {
    eyebrow: "Dove investiamo",
    title: "Sette settori. Un solo standard.",
    sub: "Impegniamo capitale su larga scala nelle industrie che plasmeranno il prossimo secolo.",
    ag: "Agricoltura", agd: "AgTech moderna e filiere agricole sostenibili su larga scala.",
    edu: "Istruzione", edud: "Sviluppo di campus e infrastrutture educative di nuova generazione.",
    re: "Immobiliare", red: "Capitale per sviluppi commerciali, residenziali e a uso misto.",
    ind: "Sviluppo Industriale", indd: "Impianti produttivi, hub logistici e zone industriali.",
    inf: "Infrastrutture", infd: "Corridoi di trasporto, asset energetici e servizi pubblici.",
    aut: "Automazione", autd: "Robotica e sistemi produttivi guidati dall'IA.",
    avi: "Aviazione", avid: "Leasing di aeromobili, finanziamento di flotte e sviluppo aeroportuale.",
  },
  loans: {
    eyebrow: "Finanziamento in debito",
    title: "Prestiti su larga scala per imprese serie.",
    desc: "Da 500K$ a oltre 100M$: strutturiamo debito commerciale per piccole e grandi imprese — approvazioni rapide, rimborso flessibile e condizioni che proteggono il tuo capitale.",
    f1: "Condizioni di rimborso flessibili",
    f2: "Processo di approvazione rapido",
    f3: "Tassi competitivi",
    f4: "Nessuna diluizione del capitale",
    slider: "Il tuo fabbisogno di finanziamento",
    cta: "Avvia una richiesta di prestito",
    steps: "Richiesta → Analisi → Approvazione → Finanziamento",
  },
  stats: { l1: "Capitale investito", l2: "Progetti finanziati", l3: "Soddisfazione dei clienti", l4: "Settori chiave" },
  marquee: ["Investimento", "Agricoltura", "Prestiti", "Istruzione", "Partnership", "Immobiliare", "Infrastrutture", "Automazione", "Aviazione"],
  team: {
    eyebrow: "Leadership",
    title: "Le persone dietro il capitale.",
    sub: "Un team dirigente diversificato con decenni di esperienza nei mercati globali.",
    r1: "Amministratore Delegato (CEO)",
    r2: "VP Senior, Investimenti Globali",
    r3: "Responsabile Infrastrutture e Finanziamento Debito",
    r4: "Direttrice, Immobiliare e Sviluppo Sostenibile",
    r5: "Direttore Finanziario (CFO)",
    r6: "Direttrice Legale e Compliance",
  },
  form: {
    eyebrow: "Contattaci",
    title: "Parlaci del suo progetto.",
    sub: "Condivida qualche dettaglio e il nostro team risponderà entro un giorno lavorativo.",
    name: "Nome completo",
    email: "Indirizzo e-mail",
    phone: "Telefono",
    company: "Azienda",
    service: "Sono interessato a",
    sector: "Settore",
    amount: "Importo del finanziamento",
    amountPh: "es. 2,5M$",
    message: "Informazioni sul progetto",
    messagePh: "Ci racconti brevemente della sua impresa e delle sue esigenze di finanziamento…",
    pick: "Selezioni un settore",
    submit: "Invia richiesta",
    submitting: "Invio in corso…",
    success: "Richiesta ricevuta — il nostro team la contatterà entro 24 ore.",
    error: "Qualcosa è andato storto. Riprovi o ci contatti su WhatsApp.",
    required: "Compili nome, e-mail e messaggio.",
    invalidEmail: "Inserisca un indirizzo e-mail valido.",
    safe: "Le sue informazioni sono sempre riservate e 100% sicure.",
  },
  contact: {
    eyebrow: "Contatti",
    title: "Parli direttamente con noi.",
    whatsapp: "WhatsApp",
    waCta: "Chatta su WhatsApp",
    email: "E-mail",
    emCta: "Invia una e-mail",
    address: "Ufficio",
    dir: "Indicazioni",
    hours: "Lun–Ven, 9:00–18:00 EST",
  },
  footer: {
    tagline: "Capitale istituzionale per i settori che plasmeranno il domani.",
    rights: "© 2026 Pacific Investment Group. Tutti i diritti riservati.",
    privacy: "Privacy",
    disclaimer: "Pacific Investment Group fornisce servizi di finanziamento commerciale e investimento. Ogni richiesta è soggetta a revisione e approvazione.",
  },
};

export const ar = {
  nav: { services: "خدماتنا", sectors: "القطاعات", loans: "القروض", team: "القيادة", contact: "اتصل بنا", cta: "اطلب تمويلاً" },
  hero: {
    eyebrow: "رأس مال مؤسسي كندي",
    line1: "رأس مال يدفع",
    line2: "الصناعات إلى الأمام",
    sub: "تنشر مجموعة باسيفيك للاستثمار استثمارات واسعة النطاق وقروضاً وشراكات استراتيجية عبر سبعة قطاعات أساسية — من الزراعة والتعليم إلى البنية التحتية والطيران.",
    cta1: "اطلب تمويلاً",
    cta2: "استكشف خدماتنا",
    scroll: "مرر للاستكشاف",
    m1: "رأس المال المُستثمَر",
    m2: "المشاريع الممولة",
    m3: "رضا العملاء",
    m4: "القطاعات الأساسية",
  },
  services: {
    eyebrow: "ما نقوم به",
    title: "ثلاث طرق نبني بها",
    sub: "رأس مال مؤسسي، مُهيكل للشركات التي تُبقي العالم في حركة.",
    s1t: "الاستثمار",
    s1d: "حقوق ملكية مؤسسية ومشاريع مشتركة تحوّل الشركات الواعدة إلى قادة في مجالاتها.",
    s1f1: "حقوق ملكية ومشاريع مشتركة",
    s1f2: "هيكلة المشاريع",
    s1f3: "نمو طويل المدى",
    s2t: "القروض",
    s2d: "تمويل ديون واسع النطاق للشركات الصغيرة والكبيرة — قروض تجارية مهيّزة للنمو.",
    s2f1: "من 500 ألف$ إلى +100 مليون$",
    s2f2: "موافقة سريعة",
    s2f3: "سداد مرن",
    s3t: "الشراكة",
    s3d: "استثمارات مشتركة استراتيجية مع إرشاد تشغيلي مباشر وشبكات عالمية.",
    s3f1: "نماذج استثمار مشترك",
    s3f2: "إرشاد تشغيلي",
    s3f3: "شبكات عالمية",
  },
  sectors: {
    eyebrow: "أين نستثمر",
    title: "سبعة قطاعات. معيار واحد.",
    sub: "نلتزم برأس مال واسع النطاق في الصناعات التي ترسم ملامح القرن القادم.",
    ag: "الزراعة", agd: "تقنيات زراعية حديثة وعمليات زراعية مستدامة واسعة النطاق.",
    edu: "التعليم", edud: "تطوير الحرم الجامعي وبنية تحتية تعليمية من الجيل الجديد.",
    re: "العقارات", red: "رأس مال تطوير تجاري وسكني ومتعدد الاستخدامات.",
    ind: "التطوير الصناعي", indd: "مصانع ومدن لوجستية ومناطق صناعية.",
    inf: "البنية التحتية", infd: "ممرات نقل وأصول طاقة ومرافق عامة.",
    aut: "الأتمتة", autd: "الروبوتات وأنظمة التصنيع المدعومة بالذكاء الاصطناعي.",
    avi: "الطيران", avid: "تأجير الطائرات وتمويل الأسطول وتطوير المطارات.",
  },
  loans: {
    eyebrow: "تمويل الديون",
    title: "قروض واسعة النطاق للأعمال الجادة.",
    desc: "من 500 ألف$ إلى أكثر من 100 مليون$، نهيكل ديون تجارية للشركات الصغيرة والكبيرة — موافقات سريعة وسداد مرن وشروط تحمي حقوق الملكية الخاصة بك.",
    f1: "شروط سداد مرنة",
    f2: "عملية موافقة سريعة",
    f3: "أسعار تنافسية",
    f4: "لا تخفيف لحصص الملكية",
    slider: "احتياجك التمويلي",
    cta: "ابدأ طلب قرض",
    steps: "الطلب ← المراجعة ← الموافقة ← التمويل",
  },
  stats: { l1: "رأس المال المُستثمَر", l2: "المشاريع الممولة", l3: "رضا العملاء", l4: "القطاعات الأساسية" },
  marquee: ["استثمار", "زراعة", "قروض", "تعليم", "شراكة", "عقارات", "بنية تحتية", "أتمتة", "طيران"],
  team: {
    eyebrow: "القيادة",
    title: "الأشخاص الذين يقفون خلف رأس المال.",
    sub: "فريق تنفيذي متنوع بخبرات تمتد لعقود في الأسواق العالمية.",
    r1: "الرئيس التنفيذي",
    r2: "نائب رئيس أول، الاستثمارات العالمية",
    r3: "رئيس البنية التحتية وتمويل الديون",
    r4: "مديرة، العقارات والتنمية المستدامة",
    r5: "المدير المالي",
    r6: "المستشارة القانونية والالتزام",
  },
  form: {
    eyebrow: "تواصل معنا",
    title: "حدثنا عن مشروعك.",
    sub: "شاركنا بعض التفاصيل وسيرد فريقنا خلال يوم عمل واحد.",
    name: "الاسم الكامل",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    company: "الشركة",
    service: "أنا مهتم بـ",
    sector: "القطاع",
    amount: "مبلغ التمويل",
    amountPh: "مثال: 2.5 مليون$",
    message: "عن مشروعك",
    messagePh: "حدثنا باختصار عن عملك واحتياجاتك التمويلية…",
    pick: "اختر قطاعاً",
    submit: "إرسال الطلب",
    submitting: "جارٍ الإرسال…",
    success: "تم استلام الطلب — سيتواصل معك فريقنا خلال 24 ساعة.",
    error: "حدث خطأ ما. حاول مجدداً أو تواصل معنا عبر واتساب.",
    required: "يرجى إدخال الاسم والبريد الإلكتروني والرسالة.",
    invalidEmail: "يرجى إدخال بريد إلكتروني صحيح.",
    safe: "معلوماتك محفوظة بسرية تامة وآمنة بنسبة 100% دائماً.",
  },
  contact: {
    eyebrow: "التواصل",
    title: "تحدث معنا مباشرة.",
    whatsapp: "واتساب",
    waCta: "محادثة عبر واتساب",
    email: "البريد الإلكتروني",
    emCta: "أرسل بريداً إلكترونياً",
    address: "المكتب",
    dir: "الاتجاهات",
    hours: "الاثنين–الجمعة، 9:00–18:00 بتوقيت شرق أمريكا",
  },
  footer: {
    tagline: "رأس مال مؤسسي للقطاعات التي ترسم ملامح الغد.",
    rights: "© 2026 مجموعة باسيفيك للاستثمار. جميع الحقوق محفوظة.",
    privacy: "الخصوصية",
    disclaimer: "تقدم مجموعة باسيفيك للاستثمار خدمات تمويل تجاري واستثماري. جميع الطلبات تخضع للمراجعة والموافقة.",
  },
};

export const zh = {
  nav: { services: "服务", sectors: "领域", loans: "贷款", team: "领导团队", contact: "联系", cta: "申请融资" },
  hero: {
    eyebrow: "加拿大机构资本",
    line1: "资本推动",
    line2: "产业前行",
    sub: "太平洋投资集团在七大核心领域部署大规模投资、贷款与战略合作——从农业、教育到基础设施与航空。",
    cta1: "申请融资",
    cta2: "了解我们的服务",
    scroll: "向下探索",
    m1: "已投资本",
    m2: "已资助项目",
    m3: "客户满意度",
    m4: "核心领域",
  },
  services: {
    eyebrow: "我们的业务",
    title: "三种共建方式",
    sub: "机构级资本，为支撑世界运转的企业而设计。",
    s1t: "投资",
    s1d: "机构股权与合资模式，助力潜力企业成长为行业领军者。",
    s1f1: "股权与合资",
    s1f2: "项目架构设计",
    s1f3: "长期增长",
    s2t: "贷款",
    s2d: "面向各类企业的大规模债务融资——为增长而设计的商业贷款。",
    s2f1: "50万至1亿美元以上",
    s2f2: "快速审批",
    s2f3: "灵活还款",
    s3t: "合作",
    s3d: "战略联合投资，提供实操性运营指导与全球网络。",
    s3f1: "联合投资模式",
    s3f2: "运营指导",
    s3f3: "全球网络",
  },
  sectors: {
    eyebrow: "投资方向",
    title: "七大领域。统一标准。",
    sub: "我们将大规模资本投入塑造下一个世纪的产业。",
    ag: "农业", agd: "现代农业科技与规模化可持续农业运营。",
    edu: "教育", edud: "校园开发与新一代教育基础设施。",
    re: "房地产", red: "商业、住宅及综合开发资本。",
    ind: "工业发展", indd: "制造工厂、物流园区与工业区。",
    inf: "基础设施", infd: "交通走廊、能源资产与公共事业。",
    aut: "自动化", autd: "机器人与人工智能驱动的制造系统。",
    avi: "航空", avid: "飞机租赁、机队融资与机场开发。",
  },
  loans: {
    eyebrow: "债务融资",
    title: "为实力企业量身定制的大额贷款。",
    desc: "从50万到1亿美元以上，我们为各类企业构建商业债务融资——快速审批、灵活还款，并保护您的股权。",
    f1: "灵活的还款条款",
    f2: "快速审批流程",
    f3: "有竞争力的利率",
    f4: "不稀释股权",
    slider: "您的融资需求",
    cta: "发起贷款咨询",
    steps: "咨询 → 审阅 → 批准 → 放款",
  },
  stats: { l1: "已投资本", l2: "已资助项目", l3: "客户满意度", l4: "核心领域" },
  marquee: ["投资", "农业", "贷款", "教育", "合作", "房地产", "基础设施", "自动化", "航空"],
  team: {
    eyebrow: "领导团队",
    title: "资本背后的掌舵人。",
    sub: "多元化高管团队，拥有数十年全球市场经验。",
    r1: "首席执行官",
    r2: "高级副总裁，全球投资",
    r3: "基础设施与债务融资负责人",
    r4: "董事，房地产与可持续发展",
    r5: "首席财务官",
    r6: "总法律顾问与合规",
  },
  form: {
    eyebrow: "联系我们",
    title: "介绍您的项目。",
    sub: "分享几个细节，我们的团队将在一个工作日内回复。",
    name: "全名",
    email: "电子邮箱",
    phone: "电话",
    company: "公司",
    service: "我感兴趣的是",
    sector: "领域",
    amount: "融资金额",
    amountPh: "例如 250万美元",
    message: "项目简介",
    messagePh: "简要介绍您的企业与融资需求…",
    pick: "请选择领域",
    submit: "提交咨询",
    submitting: "提交中…",
    success: "已收到咨询——我们的团队将在24小时内与您联系。",
    error: "出了点问题。请重试或通过 WhatsApp 联系我们。",
    required: "请填写您的姓名、邮箱和留言。",
    invalidEmail: "请输入有效的电子邮箱地址。",
    safe: "您的信息将被严格保密，100%安全。",
  },
  contact: {
    eyebrow: "联系方式",
    title: "直接与我们对话。",
    whatsapp: "WhatsApp",
    waCta: "通过 WhatsApp 聊天",
    email: "邮箱",
    emCta: "发送邮件",
    address: "办公室",
    dir: "获取路线",
    hours: "周一至周五，9:00–18:00（北美东部时间）",
  },
  footer: {
    tagline: "机构资本，助力塑造未来的产业。",
    rights: "© 2026 太平洋投资集团。版权所有。",
    privacy: "隐私政策",
    disclaimer: "太平洋投资集团提供商业融资与投资服务。所有咨询均须经审核与批准。",
  },
};
